import { Injectable } from '@angular/core';
import { Item } from '../models/catalog.model';

@Injectable({
  providedIn: 'root',
})
export class FavoriteProductService {

  constructor() {}

  public isFavorite(product: Item, favoriteItems: String[]): boolean {
    return favoriteItems.includes(product.id);
  }

  updateFavoriteProducts(
    favoriteItems: String[],
    filteredProductList: Item[][],
    favoriteProducts: Item[],
  ) {
    const favoriteItemsSet = new Set(favoriteItems);

    const productsToAdd = [];
    const productsToRemove = [];

    for (const subArray of filteredProductList) {
      for (const product of subArray) {
        const isFavorite = favoriteItemsSet.has(product.id);
        const isInFavoriteProducts = favoriteProducts.some(
          (fp) => fp.id === product.id
        );

        if (
          isFavorite &&
          !isInFavoriteProducts &&
          !productsToAdd.some((p) => p.info.id === product.id)
        ) {
          productsToAdd.push(product);
        } else if (!isFavorite && isInFavoriteProducts) {
          productsToRemove.push(product);
        }
      }
    }

    if (productsToAdd.length) {
      favoriteProducts = [...favoriteProducts, ...productsToAdd];
    }

    if (productsToRemove.length) {
      favoriteProducts = favoriteProducts.filter(
        (fp) => !productsToRemove.some((pr) => pr.info.id === fp.id)
      );
    }

    return favoriteProducts;
  }

}
